import common from './common';
import bill from './bill';
import pay from './pay';
import account from './account';
import order from './order';

export default {
  common,
  pay,
  bill,
  account,
  order,
};
